export const COLORS_HEX = {
    EBF0F5: '#EBF0F5',
    F3F4F6: '#F3F4F6',
    E5E7EB: '#E5E7EB',
    BG4B5563: '#4B5563',
    BG9E9E9E: '#9E9E9E',
    BG92400E: '#92400E',
    FFFBEB: '#FFFBEB',
    E11D20: '#E11D20',
    FBEFF2: '#FBEFF2',
    BG008732: '#008732',
    F0FDF4: '#F0FDF4',
    COLOR_8D2625: '#8d2625',
    COLOR_FAD6D6: '#fad6d6',
}